<template>
   <footer role="contentinfo" itemscope itemtype="https://schema.org/WPFooter">
      <!-- Top navigation footer -->
      <div v-if="footerenabled" class="footer-nav">
         <div class="footer-nav-wrapper">
            <div
               v-for="(itemA, index) in footerNavigationData.items"
               v-show="index !== 3 && index !== 5"
               :key="index"
               class="footer-nav-list product-nav-list"
            >
               <!-- Normal item -->
               <ListItem v-if="index !== 2" :data="itemA" />

               <!-- Special Docs/Integrations column -->
               <div v-else>
                  <div class="heading text-uppercase">{{ itemA.header }}</div>
                  <ul class="list-unstyled">
                     <li>
                        <a target="_blank" rel="noopener" href="https://www.fusioncharts.com/dev">
                           Dev Center (Docs)
                        </a>
                     </li>
                     <li>
                        <a href="/integrations">Integrations</a>
                     </li>
                     <li>
                        <a
                           target="_blank"
                           rel="noopener"
                           href="https://www.fusioncharts.com/dev/upgrading/change-log"
                        >
                           Version History
                        </a>
                     </li>
                     <li>
                        <a target="_blank" rel="noopener" href="https://forum.fusioncharts.com/">
                           Forum
                        </a>
                     </li>
                  </ul>
               </div>

               <!-- Append conditional items -->
               <ListItem v-if="index === 2" :data="footerNavigationData.items[3]" />
               <ListItem v-if="index === 4" :data="footerNavigationData.items[5]" />
            </div>
         </div>
      </div>

      <!-- Social & copyright -->
      <div v-if="soicalfooterenabled" class="footer-bottom">
         <div class="container">
            <div class="row">
               <div class="col-xs-12 col-sm-12 col-md-7">
                  <ul
                     class="list-inline list-unstyled social-icons"
                     itemscope
                     itemtype="https://schema.org/Organization"
                  >
                     <li v-for="(social, i) in socials" :key="i" :class="social.name">
                        <a
                           :title="social.title"
                           itemprop="sameAs"
                           :href="social.url"
                           target="_blank"
                           rel="noopener"
                        >
                           <i :class="social.icon" />
                        </a>
                     </li>
                  </ul>
                  <div class="small copyright no-margin">
                     &copy; {{ currentYear }} FusionCharts - An Idera, Inc. Company. All Rights
                     Reserved.
                  </div>
               </div>
            </div>
         </div>
      </div>
   </footer>
</template>

<script>
import { mapState } from 'vuex';
import ListItem from './ListItems';

export default {
   name: 'PrimaryFooter',
   components: { ListItem },

   props: {
      footerenabled: { type: Boolean, default: true },
      soicalfooterenabled: { type: Boolean, default: true },
   },

   computed: {
      ...mapState(['footerNavigationData']),
      currentYear: () => new Date().getFullYear(),
      socials: () => [
         {
            name: 'twitter',
            title: 'Twitter',
            url: 'https://x.com/fusioncharts',
            icon: 'fc_twitter',
         },
         {
            name: 'linkedin',
            title: 'LinkedIn',
            url: 'https://www.linkedin.com/company/fusioncharts/',
            icon: 'fc_linkedin',
         },
         {
            name: 'facebook',
            title: 'Facebook',
            url: 'https://www.facebook.com/FusionChart/',
            icon: 'fc_facebook',
         },
         {
            name: 'github',
            title: 'GitHub',
            url: 'https://github.com/fusioncharts/',
            icon: 'fc_github',
         },
         { name: 'blog', title: 'Blog', url: 'https://www.fusioncharts.com/blog/', icon: 'fc_rss' },
      ],
   },

   asyncData({ store }) {
      return store.dispatch('NAVBAR_NAVIGATION_DATA_FETCH', {
         section: 'footer',
         stateName: 'footerNavigationData',
      });
   },
};
</script>
